/**
 * Diagnostic centers' postal code field is treated as digits-only (the
 * form's own placeholder, "12345", already implied this) - previously
 * had no format validation at all, just a "not empty" check, so letters
 * and special characters silently passed through.
 */
const POSTAL_CODE_REGEX = /^\d+$/;

export function isValidPostalCode(postalCode: string): boolean {
  return POSTAL_CODE_REGEX.test(postalCode);
}
